import * as types from './types'
import { USERS_SEARCH, TOP_FLIRTS, MY_FLIRTS, FLIRTED_WITH_ME, MUTUAL_FLIRTS } from 'common/endpoints'
import { push } from 'connected-react-router'

const fetchSearchUsers = ({ filters = '', page, pageSize = 18, searchId, ...rest }, url) => ({
  type: types.FETCH_USERS,
  filter: filters,
  meta: {
    url: url || USERS_SEARCH,
    params: {
      filters,
      pageSize,
      ...(page ? { pageNum: page } : {}),
      ...(searchId ? { srchN: searchId } : {}),
      ...rest,
    },
  },
})

export const fetchUsers = params => {
  switch (params.filters) {
    case 'flirts':
      return {
        type: types.FETCH_TOP_FLIRTS,
        meta: { url: TOP_FLIRTS },
      }
    case 'myFlirts':
      return fetchSearchUsers(params, MY_FLIRTS)
    case 'withMe':
      return fetchSearchUsers(params, FLIRTED_WITH_ME)
    case 'mutual':
      return fetchSearchUsers(params, MUTUAL_FLIRTS)
    default:
      return fetchSearchUsers(params)
  }
}

export const setFilters = filters => push(`?filters=${filters}`)

const seeList = path => ({
  type: types.SEE_LIST,
  meta: { path },
})

const hideList = path => ({
  type: types.HIDE_LIST,
  meta: { path },
})

export const watchList = path => dispatch => {
  dispatch(seeList(path))
  return () => setTimeout(() => dispatch(hideList(path)), 10000)
}
